
export type PolicyType = {
  fixedDeposit: {
    enabled: boolean;
    maxPercentage: number;
    minRating: string;
    maxTenor: number;
    minInterestRate: number;
    allowedBanks: string[];
  };
  liquidFunds: {
    enabled: boolean;
    maxPercentage: number;
    minRating: string;
    expectedReturns: number;
    autoRedemption: boolean;
    allowedFunds: string[];
  };
  general: {
    maxSingleInstitutionExposure: number;
    requireTwoLevelApproval: boolean;
    autoReinvestMaturity: boolean;
    minimumLiquidityBuffer: number;
  };
};

export const defaultPolicy: PolicyType = {
  fixedDeposit: {
    enabled: true,
    maxPercentage: 80,
    minRating: "AA",
    maxTenor: 12,
    minInterestRate: 5.5,
    allowedBanks: ["HDFC Bank", "SBI", "ICICI Bank", "Axis Bank", "Kotak Bank"]
  },
  liquidFunds: {
    enabled: true,
    maxPercentage: 50,
    minRating: "AAA",
    expectedReturns: 6.5,
    autoRedemption: false,
    allowedFunds: ["SBI Liquid Fund", "HDFC Liquid Fund", "Aditya Birla Sun Life Liquid Fund", "ICICI Prudential Liquid Fund"]
  },
  general: {
    maxSingleInstitutionExposure: 25,
    requireTwoLevelApproval: true,
    autoReinvestMaturity: false,
    minimumLiquidityBuffer: 15
  }
};
